import {ValueDefinition} from '@/model/types';

export enum Contributor {
  CONTRACTHOLDER = 'DV-11#0',
  SPOUSAL = 'DV-11#1',
}

export const DV_11 = {
  id: 'DV-11',
  description: {
    fr: 'Cotisant',
    en: 'Contributor',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Preneur cotisant',
        en: 'Contributing contractholder',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Conjoint cotisant',
        en: 'Spousal',
      },
    },
  ],
} as const satisfies ValueDefinition;
